import { FETCH_DSO_LIST, MAP_DSO, UPDATE_DSO_CONFIG } from './types';
import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';

const dentalCorpBackend = getDentalCorpBackend();

export const fetchDSOList = (pageNumber, pageSize, searchText) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchDSOList(getState(), pageNumber, pageSize, searchText, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: FETCH_DSO_LIST, payload: response.response });
		}
	};
};

export const mapDSO = (dsoId, action, source, bucket) => {
	const body = {
		action: action,
		source: source,
		bucket: bucket,
	};
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.mapDSO(getState(), dsoId, body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: MAP_DSO, payload: response.response });
		}
	};
};

export const updateDSOConfig = (dsoId, body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.updateDSOConfig(getState(), dsoId, body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: UPDATE_DSO_CONFIG, payload: response.response });
		}
	};
};
